import ProductControl from "./productControl";

export default function NewProduct() {
  return <ProductControl />;
}
